module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/door/door.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/door/door.obj
// module id = 477
// module chunks = 0